import { makeStyles } from "@mui/styles";

export const useEntityIconStyles = makeStyles({
    root: {
        fontSize: "1rem",
    },
});
